import Bowser from 'bowser';

export const testHelpers = {
    setWindowLocationHost(host){
        Object.defineProperty(window.location, 'host', { writable: true, value: host});
    },
    resetWindowLocationHost(){
        Object.defineProperty(window.location, 'host', { writable: true, value: 'localhost'});
    }
}

  
export const getUsersBrowserVersion = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    return browser.getBrowser();
};




// WEBPACK FOOTER //
// ./src/common/utils.js